import React, {useState} from "react";
import {Button, Input} from "@varymadellc/my-weed-club-component-library";
import {useAuth} from "@/providers/AuthProvider";
import {useSiteMessage} from "@/providers/SiteMessageProvider";
import {apiGet, extractPayloadFromResponse} from "@/services/apiService";
import Page from "@/layout/Page";

export default function ForgotPassword() {
    const {authToken} = useAuth();

    const {setMessage} = useSiteMessage();

    const [email, setEmail] = useState<string>('');

    const onSubmitHandler = async (event: any) => {
        event.preventDefault();
        try {
            if (!email) {
                throw new Error("Please enter an email address.");
            }

            const response = await apiGet(`/password/forgot-password?email=${email}`, authToken);

            const status = await extractPayloadFromResponse(response);

            if (Number(status.status)   === 204) {
                setMessage("If your account exist, then you should receive an email to reset your password.");

                setEmail('');

                return;
            }

            setMessage("Something went wrong. Please try again later.");
        } catch(error: any) {
            setMessage(error.message);
        }
    }

    const emailHandler = async ({target: {value}}: any) => {
        setEmail(value);
    }

    return (
        <Page title="Forgot the password did we? It's all good fellow stoner.">
            <form className="mx-auto w-8/12" onSubmit={onSubmitHandler}>
                <label htmlFor="email">Email:</label>
                <br/>
                <Input className="w-full" value={email} type="text" onChange={emailHandler} id="email"/>
                <div className="text-center">
                    <br/>
                    <Button type="submit">Retrieve Lost Password</Button>
                </div>
            </form>
        </Page>
    );
}